import { render, staticRenderFns } from "./create-payment.vue?vue&type=template&id=df8cedfe&scoped=true"
import script from "./create-payment.vue?vue&type=script&lang=js"
export * from "./create-payment.vue?vue&type=script&lang=js"
import style0 from "./create-payment.vue?vue&type=style&index=0&id=df8cedfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8cedfe",
  null
  
)

export default component.exports